module.exports = __webpack_public_path__ + "static/media/ursina_badilatti_mood.5e5149f5.jpg";